<template>
	<div class="left-side" v-if="profile">
    <div class="page-header m-n">
      <h1 class="m-n text-center text-u-c title-font">Snapshot</h1>
    </div>
		<div class="row m-n">
      <div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n">
				<small class="block text-u-c text-font">Registration no.</small>
				<span class="style-font">{{ profile.corporateProfile.reg_number }}</span>
        <span v-if="!profile.corporateProfile.reg_number" class="style-font"> - </span>
			</div>
      <div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n">
				<small class="block text-u-c text-font">Founded</small>
				<span class="style-font">{{ profile.corporateProfile.founded_year }}</span>
        <span v-if="!profile.corporateProfile.founded_year" class="style-font"> - </span>
			</div>
			<div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n" >
				<small class="block text-u-c text-font">Type</small>
				<span class="style-font">{{ getTypeName(profile.corporateProfile.type_id) }}</span>
        <span v-if="!profile.corporateProfile.type_id" class="style-font"> - </span>
			</div>
			<div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n" >
				<small class="block text-u-c text-font">Industry</small>
				<span class="style-font">{{ getIndustryName(profile.corporateProfile.industry_id) }}</span>
        <span v-if="!getIndustryName(profile.corporateProfile.industry_id)" class="style-font"> - </span>
			</div>
      <div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n" >
				<small class="block text-u-c text-font">Headcount</small>        
				<span class="style-font">{{ profile.corporateProfile.no_employee }}</span>
        <span v-if="!profile.corporateProfile.no_employee > 0" class="style-font"> - </span>
			</div>
      <div class="col-lg-4 col-sm-4 text-center m-b-md p-x-n" >
				<small class="block text-u-c text-font">Revenues</small>
				<span class="style-font">{{ profile.corporateProfile.revenues }}</span>
        <span v-if="!profile.corporateProfile.revenues" class="style-font"> - </span>
			</div>			
			
			<div v-if="tagNamesShow()" class="col-lg-12 col-sm-12 text-center m-t-lg p-x-n scrollMB">
				<small class="block text-u-c text-font">Business Services</small>
				<div class="buttonPosition m-t-sm">
					<span class="m-r-sm" v-for="tagName in tagNames">
						<button @click="goProfiles(tagName.id)" type="button" class="btn btn-secondary btn-sm btn-bs m-b-sm">{{ tagName.name }}</button>
					</span>
				</div>
			</div>			
			
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
  import ApiService from "../../../../services/ApiService";

	export default {
		computed : {
			...mapGetters([
				'types',
				'industries',
				'profile',
				'getTypeName',
				'getIndustryName'
			]),
		},
		data() {
			return {
				tags: [],
				tagNames: [],
        apiService: new ApiService(),
        accountService: new ApiService(process.env.ACCOUNT_URL, window.user.oauth_token),
			}
		},
		created() {
			this.fetchBusinessServices();
		},
		watch: {
			tags: function(to){
				this.profile.corporateProfile.business_services.map(index => {
					const tagName = to.find(tag => tag.id === index)
					this.tagNames.push(tagName);
				})
			}
		},
		mounted(){
      
		},
		methods: {
      goProfiles(tagName = null) {
				if(!tagName) return;
        window.location.assign(`${window.user.community_url}/${window.user.community_domain}/default/corporate#/tag/${tagName}`);
			},
			fetchBusinessServices() {
				this.accountService.get(`/api/business-services`)
				.then(res => {
					this.tags = res.data;
				})
			},
      tagNamesShow(){
        if(this.tagNames.length > 0){
          return true;
        }
        else {
          return false;
        }
      }
		},
	}
</script>
<style lang="scss" scoped>  
@media only screen and (min-width: 1200px) {
  .left-side .page-header {
    padding-top: 20px;
    padding-bottom: 15px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  }
  .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    letter-spacing: 0.39px;
    color: #888888;
  }
  .style-font {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }  
  .scrollMB .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: normal;
    color: #888888;
  }
  .btn-bs {
    border-radius: 3px; 
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: #555;
    background-color: #fff;
    border: 1px solid #bbb;
    padding: 5px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    
  }
	.btn-bs:hover, .btn-bs:focus, .btn-bs.focus {
    font-weight: 500;
    color: #fff;
		background-color: #777;
    padding: 5px 15px;
    text-overflow: unset;
    overflow: visible;
    max-width: max-content;
	}
}
@media only screen and (max-width: 1199px) and (min-width: 992px) {
  .left-side .page-header {
    padding-top: 20px;
    padding-bottom: 15px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  }
  .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    letter-spacing: 0.39px;
    color: #888888;
  }
  .style-font {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }  
  .scrollMB .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: normal;
    color: #888888;
  }
  .btn-bs {
    border-radius: 3px; 
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: #555;
    background-color: #fff;
    border: 1px solid #bbb;
    padding: 5px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    
  }
	.btn-bs:hover, .btn-bs:focus, .btn-bs.focus {
    font-weight: 500;
    color: #fff;
		background-color: #777;
    padding: 5px 15px;
    text-overflow: unset;
    overflow: visible;
    max-width: max-content;
	}
}
 @media only screen and (max-width: 991px) and (min-width: 768px) {
  .left-side .page-header {
    padding-top: 20px;
    padding-bottom: 15px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  }
  .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    letter-spacing: 0.39px;
    color: #888888;
  }
  .style-font {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }  
  .scrollMB .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: normal;
    color: #888888;
  }
  .btn-bs {
    border-radius: 3px; 
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: #555;
    background-color: #fff;
    border: 1px solid #bbb;
    padding: 5px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    
  }
	.btn-bs:hover, .btn-bs:focus, .btn-bs.focus {
    font-weight: 500;
    color: #fff;
		background-color: #777;
    padding: 5px 15px;
    text-overflow: unset;
    overflow: visible;
    max-width: max-content;
	}
}
@media only screen and (max-width: 767px) {
  .left-side {
    padding-left: 30px;
    padding-right: 30px;
  }
  .left-side .page-header {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .title-font {
    font-weight: 300;
    font-size: 20px;
    line-height: 20px;
    color: #000000;
  }
  .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 11px;
    letter-spacing: 0.39px;
    color: #888888;
  }
  .style-font {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }  
  .scrollMB .text-font {
    font-weight: normal;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: normal;
    color: #888888;
  }
  .btn-bs {
    border-radius: 3px; 
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    color: #555;
    background-color: #fff;
    border: 1px solid #bbb;
    padding: 5px 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    
  }
	.btn-bs:hover, .btn-bs:focus, .btn-bs.focus {
    font-weight: 500;
    color: #fff;
		background-color: #777;
    padding: 5px 15px;
    text-overflow: unset;
    overflow: visible;
    max-width: max-content;
	}
}
</style>

